import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import inviteService from '../../services/inviteService';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-toastify';
import './InviteSection.css';

const InviteSection = () => {
    const { t } = useTranslation();
    const { token } = useAuth();
    const [invites, setInvites] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchInvites = useCallback(async () => {
        try {
            setLoading(true);
            const data = await inviteService.getMyInvites(token);
            setInvites(data);
        } catch (error) {
            console.error(error);
            toast.error(t('error_fetching_invites', 'Erro ao carregar seus convites.'));
        } finally {
            setLoading(false);
        }
    }, [token, t]);

    useEffect(() => {
        fetchInvites();
    }, [fetchInvites]);

    const copyToClipboard = (code) => {
        navigator.clipboard.writeText(code);
        toast.info(t('invite_code_copied', 'Código copiado! Envie para um amigo.'));
    };

    const availableInvites = invites.filter(i => i.status === 'AVAILABLE');

    if (loading) return <div className="invite-loading">{t('loading')}...</div>;

    return (
        <div className="invite-section-container">
            <h3>🎟️ {t('your_invites_title', 'Seus Convites')}</h3>
            <p className="invite-desc">{t('invite_desc_text', 'Convide outros artistas para a plataforma. Pedidos com convite têm prioridade na análise.')}</p>

            <div className="invite-list">
                {availableInvites.length === 0 ? (
                    <p className="no-invites">{t('no_invites_available', 'Você não possui convites disponíveis no momento.')}</p>
                ) : (
                    availableInvites.map(invite => (
                        <div key={invite.id} className="invite-card available">
                            <div className="invite-info">
                                <span className="invite-code">{invite.code}</span>
                                <span className="invite-status status-available">
                                    {t('available', 'Disponível')}
                                </span>
                            </div>
                            <button
                                className="copy-invite-btn"
                                onClick={() => copyToClipboard(invite.code)}
                            >
                                {t('copy', 'Copiar')}
                            </button>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default InviteSection;
